import { useLogMarketAnalyticsEvent } from './useLogMarketAnalyticsEvent';
import { useCallback } from 'react';
import type { Coupon } from 'shared/src/api/marketCouponService/getMarketCouponList';

export const useLogCompleteDownloadCoupon = (marketId: number) => {
  const logMarket = useLogMarketAnalyticsEvent(marketId);
  return useCallback(
    (params: { coupon?: Coupon; isDownloadAll?: boolean }) => {
      logMarket({
        name: 'COMPLETE_DOWNLOAD_COUPON',
        analytics: {
          COUPON_SNO: params.coupon?.sno?.toString() ?? null,
          COUPON_NAME: params.coupon?.name ?? null,
          ISSUER_TYPE: 'ADMIN',
          APPLICABLE_TYPE: null,
          ENABLE_STACKABLE_COUPON: 0,
          IS_DOWNLOAD_ALL: params.isDownloadAll ? 1 : 0,
        },
      });
    },
    [logMarket],
  );
};
